(() => {
  const SNAPSHOT_KEY = 'kh:cart-prices:v1';
  const PENDING_KEY = 'kh:cart-price-notice:v1';

  const storage = (type) => {
    try {
      return window[type];
    } catch (_error) {
      return null;
    }
  };

  const read = (store, key) => {
    try {
      return JSON.parse(store?.getItem(key) || 'null');
    } catch (_error) {
      return null;
    }
  };

  const write = (store, key, value) => {
    try {
      store?.setItem(key, JSON.stringify(value));
    } catch (_error) {
      // Price-change messaging is an enhancement; blocked storage must not block the cart.
    }
  };

  const itemPrice = (item) => Number(item?.original_price ?? item?.price ?? 0);
  const itemId = (item) => String(item?.variant_id ?? item?.id ?? '');

  const snapshot = (cart) => ({
    token: String(cart?.token || ''),
    currency: String(cart?.currency || ''),
    items: Object.fromEntries((cart?.items || []).map((item) => [itemId(item), {
      price: itemPrice(item),
      title: String(item.product_title || item.title || '')
    }]))
  });

  const inspect = (cart) => {
    const next = snapshot(cart);
    const store = storage('localStorage');
    const previous = read(store, SNAPSHOT_KEY);
    const sameCart = previous && (!previous.token || !next.token || previous.token === next.token);
    const changes = [];

    if (sameCart && previous.items) {
      Object.entries(next.items).forEach(([variantId, item]) => {
        const oldItem = previous.items[variantId];
        if (!oldItem || Number(oldItem.price) === Number(item.price)) return;
        changes.push({
          variantId,
          title: item.title,
          previousPrice: Number(oldItem.price),
          currentPrice: Number(item.price)
        });
      });
    }

    write(store, SNAPSHOT_KEY, next);
    return changes;
  };

  const rememberPending = (changes) => write(storage('sessionStorage'), PENDING_KEY, changes);

  const consumePending = () => {
    const store = storage('sessionStorage');
    const pending = read(store, PENDING_KEY) || [];
    try {
      store?.removeItem(PENDING_KEY);
    } catch (_error) {
      // Ignore unavailable session storage and continue with the current cart.
    }
    return pending;
  };

  window.KohinoorCartPriceChanges = { inspect, rememberPending, consumePending };
})();
